module.exports = __webpack_public_path__ + "static/img/IMG_20240210_171704.44a4ea5f.jpg";